import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';

import { ROUTES } from './constants';

import { Container } from './components/_atoms';
import NavBar from './components/NavBar';
import ProtectedRoute from './components/protectedRoute';

import Applications from './pages/applications';
import CreateApplication from './pages/createApplication';
import SingleApplication from './pages/application';
import Schools from './pages/schools';
import Courses from './pages/courses';
import Course from './pages/course';
import CourseMappings from './pages/courseMappings';
import NotFound from './pages/notFound';
import Users from './pages/users';
import School from './pages/school';
import User from './pages/user';
import Home from './pages/home';
import { Grid2 as Grid } from '@mui/material';

import ApplicationsAdmin from './pages/applicationsAdmin';
import ApplicationRowsAdmin from './pages/applicationRowsAdmin';
import MasterTracks from './pages/masterTracks';
import MasterTrack from './pages/masterTrack';
import SideMenu from './components/sideMenu/sideMenu';

const App = () => {
	const [sideMenuIsOpen, setSideMenuIsOpen] = React.useState<boolean>(false);

	const toggleSideMenu = () => {
		setSideMenuIsOpen(!sideMenuIsOpen);
	};

	return (
		<Container>
			<NavBar toggleSideMenu={toggleSideMenu} />
			<Grid container style={{ justifyContent: 'center' }}>
				<Grid
					style={{
						marginTop: 70,
						padding: 20,
						backgroundColor: 'white',
						width: '1400px',
						maxWidth: '95vw',
					}}
				>
					<Routes>
						<Route
							path={`${ROUTES.APPLICATION}/:id`}
							element={
								<ProtectedRoute>
									<SingleApplication />
								</ProtectedRoute>
							}
						/>
						<Route
							path={ROUTES.APPLICATIONS}
							element={
								<ProtectedRoute>
									<Applications />
								</ProtectedRoute>
							}
						/>
						<Route
							path={ROUTES.APPLICATIONS_ADMIN}
							element={
								<ProtectedRoute isAdmin>
									<ApplicationsAdmin />
								</ProtectedRoute>
							}
						/>
						<Route
							path={ROUTES.CREATE_APPLICATION}
							element={
								<ProtectedRoute>
									<CreateApplication />
								</ProtectedRoute>
							}
						/>
						<Route
							path={ROUTES.APPLICATION_ROWS}
							element={
								<ProtectedRoute isAdmin>
									<ApplicationRowsAdmin />
								</ProtectedRoute>
							}
						/>
						<Route
							path={ROUTES.SCHOOLS}
							element={
								<ProtectedRoute isAdmin>
									<Schools />
								</ProtectedRoute>
							}
						/>
						<Route
							path={`${ROUTES.SCHOOL}/:id`}
							element={
								<ProtectedRoute isAdmin>
									<School />
								</ProtectedRoute>
							}
						/>
						<Route
							path={`${ROUTES.COURSES}/:schoolId?`}
							element={
								<ProtectedRoute isAdmin>
									<Courses />
								</ProtectedRoute>
							}
						/>
						<Route
							path={`${ROUTES.COURSE}/:courseId`}
							element={
								<ProtectedRoute isAdmin>
									<Course />
								</ProtectedRoute>
							}
						/>
						<Route
							path={ROUTES.USERS}
							element={
								<ProtectedRoute isAdmin>
									<Users />
								</ProtectedRoute>
							}
						/>
						<Route
							path={`${ROUTES.USER}/:id`}
							element={
								<ProtectedRoute isAdmin>
									<User />
								</ProtectedRoute>
							}
						/>
						<Route
							path={`${ROUTES.MASTERTRACK}/:id`}
							element={
								<ProtectedRoute isAdmin>
									<MasterTrack />
								</ProtectedRoute>
							}
						/>
						<Route
							path={`${ROUTES.MASTERTRACKS}`}
							element={
								<ProtectedRoute isAdmin>
									<MasterTracks />
								</ProtectedRoute>
							}
						/>
						<Route
							path={ROUTES.COURSE_MAPPINGS}
							element={
								<ProtectedRoute>
									<CourseMappings />
								</ProtectedRoute>
							}
						/>
						<Route path="/" element={<Home />} />
						<Route path="*" element={<NotFound />} />
					</Routes>
				</Grid>
			</Grid>
			<SideMenu isOpen={sideMenuIsOpen} toggleOpen={toggleSideMenu} />
		</Container>
	);
};

export default App;
